var _radialGradient, _radialGradient2, _linearGradient, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-34.5 0 1022 1022",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: -14516,
    cy: -8331.1,
    r: 450.88,
    fx: -14544,
    gradientTransform: "matrix(.76 .03 -.05 1.12 11552 10071)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ffbf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#ff8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#e0255a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#cc2477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42482"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "B",
    cx: -7564.7,
    cy: -7923.6,
    r: 791.23,
    gradientTransform: "matrix(1.23 0 0 1.23 9929.8 9899.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ccda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#0083ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#007af9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0060e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#005fe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#2639ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#401e84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4a1475"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 540.67,
    x2: 349.23,
    y1: 729.19,
    y2: 102.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000f43",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#001962",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002079",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "D",
    cx: -8295.9,
    cy: -6518.6,
    r: 266.89,
    gradientTransform: "matrix(1.22 .12 -.12 1.22 10304 9602)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42482"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "E",
    cx: -8320.1,
    cy: -6774.5,
    r: 445.68,
    gradientTransform: "matrix(1.22 .12 -.12 1.22 10304 9602)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ffaf0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ff7a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ff4e26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ff2c2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ff1434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ff0538"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0039"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "F",
    cx: -8257,
    cy: -6361.3,
    r: 408.96,
    gradientTransform: "matrix(1.22 .12 -.12 1.22 10304 9602)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#620700"
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "G",
    cx: 715.19,
    cy: 394.04,
    r: 782.18,
    fx: 743.17,
    fy: 380.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ffbf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#ff8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ff272d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f92433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#e91c45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#cf0e62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#b5007f"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "H",
    cx: 670.34,
    cy: 31.29,
    r: 891.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ffea00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ffba00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ff9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ff6711"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ff4a1d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 150.45,
    x2: 534.39,
    y1: 375.21,
    y2: 316.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42482",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#ff272d",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ff2c2c",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ff7a1a",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ffb20d",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ffd605",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe302"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 142.58,
    x2: 102.54,
    y1: 265.27,
    y2: 121.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#891551",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42482",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    x1: 220.55,
    x2: 303.03,
    y1: 465.39,
    y2: 580.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#891551",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#ff272d",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff272d",
    stopOpacity: 0
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 378.25,
    x2: 385.79,
    y1: 667.12,
    y2: 593.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c42482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#c42482",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c42482",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#c42482",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#c42482",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#c42482",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#c42482",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#c42482",
    stopOpacity: 0
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 620.53,
    x2: 926.19,
    y1: 36.12,
    y2: 719.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff14f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ffee4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ffe643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ffd834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ffc41e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ffab02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ffa900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ffa000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9100"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 680.88,
    x2: 536.1,
    y1: 429.21,
    y2: 817.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ff8e00",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ff8e00",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ff8e00",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#ff8e00",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#ff8e00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#ff8e00",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ff8e00",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ff8e00",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ff8e00",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#ff8e00",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8e00",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M770.28 91.56c-23.95 27.88-35.1 90.64-10.82 154.26s61.5 49.8 84.7 114.67c30.62 85.6 16.37 200.6 16.37 200.6s36.8 106.6 62.47-6.63c56.8-212.7-152.72-410.5-152.72-462.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M478.07 974.64c245.24 0 443.9-199.74 443.9-446s-198.66-446-443.66-446S34.65 282.32 34.65 528.6c-.47 246.53 198.42 446.03 443.42 446.03z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M810.67 803.64a246.89 246.89 0 01-30.12 18.18 704 704 0 0038.3-63c9.46-10.47 18.13-20.65 25.2-31.65 3.44-5.4 7.3-12.08 11.42-19.82 24.92-44.9 52.4-117.56 53.18-192.2v-5.66a257.6 257.6 0 00-5.71-55.75l.56 4.3-.64-3.3c.37 2 .66 4 1 6 5.1 43.22 1.47 85.37-16.68 116.45l-.87 1.32c9.4-47.23 12.56-99.4 2.1-151.6 0 0-4.2-25.38-35.38-102.44-18-44.35-49.83-80.72-78-107.2-24.7-30.55-47.1-51-59.47-64.06-25.82-27.2-36.64-47.57-41.1-60.87-3.85-1.93-53.14-49.8-57.05-51.63-21.5 33.35-89.16 137.67-57 235.15 14.58 44.17 51.47 90 90.07 115.74 1.7 1.94 23 25 33.1 77.16 10.45 53.85 5 95.86-16.54 158-25.3 54.5-90.07 108.4-150.72 113.9-129.67 11.78-177.15-65.1-177.15-65.1 46.34 18.52 97.57 14.65 128.72-4.56 31.4-19.43 50.4-33.83 65.8-28.15C548.86 648.43 561 632 550.1 615a78.5 78.5 0 00-79.4-34.57c-31.43 5.1-60.23 30-101.4 5.9a85.53 85.53 0 01-7.73-5.06c-2.7-1.8 8.83 2.72 6.13.7-8-4.35-22.2-13.84-25.88-17.22-.6-.56 6.22 2.18 5.6 1.62-38.5-31.7-33.7-53.13-32.5-66.57 1-10.75 8-24.52 19.75-30.1 5.7 3.1 9.24 5.48 9.24 5.48l-3.74-7.58c.46-.2.9-.15 1.36-.34 4.66 2.25 15 8.1 20.4 11.67 7.07 5 9.33 9.44 9.33 9.44s1.86-1 .48-5.37c-.5-1.78-2.65-7.45-9.65-13.17h.44a81.2 81.2 0 0111.87 8.24c2-7.18 5.53-14.68 4.75-28.1-.48-9.43-.26-11.87-1.92-15.5-1.5-3.13.83-4.35 3.42-1.1a32.83 32.83 0 00-2.21-7.4v-.24c3.23-11.24 68.25-40.46 73-43.88a67.36 67.36 0 0019.13-20.8c3.62-5.76 6.34-13.85 7-26.1.36-8.84-3.76-14.73-69.5-21.62-18-1.77-28.53-14.8-34.53-26.82-1.1-2.6-2.2-4.94-3.33-7.28a58 58 0 01-2.56-8.43c10.75-30.87 28.8-57 55.37-76.7 1.45-1.32-5.78.34-4.34-1 1.7-1.54 12.7-6 14.8-7 2.54-1.2-10.88-6.9-22.73-5.5-12.07 1.36-14.63 2.8-21.07 5.53 2.67-2.66 11.17-6.15 9.18-6.13-13 2-29.18 9.56-43 18.12a10.73 10.73 0 01.83-4.35c-6.44 2.73-22.26 13.8-26.87 23.14a44.33 44.33 0 00.27-5.4 84.48 84.48 0 00-13.19 13.82l-.24.22c-37.36-15-70.23-16-98.05-9.28-6.1-6.1-9.06-1.64-22.9-32.07-.94-1.83.72 1.8 0 0-2.28-5.9 1.4 7.87 0 0-23.28 18.37-53.92 39.2-68.63 53.9-.18.6 17.16-4.9 0 0-6 1.72-5.6 5.28-6.5 37.5-.22 2.44 0 5.18-.22 7.38-11.75 15-19.75 27.64-22.78 34.2-15.2 26.18-31.93 67-48.15 131.55a334.36 334.36 0 0125.79-50.32c-13.5 34.27-26.53 88.08-29.13 170.94a483.61 483.61 0 0112.53-50.66 473 473 0 0034.73 201.07c9.33 22.82 24.76 57.46 51 95.4C226.9 902 343.3 956 472.2 956c134.58 0 255.43-58.87 338.46-152.36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M711.1 866.7c162.87-18.86 235-186.7 142.38-190C769.85 674 634 875.6 711.1 866.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M865.2 642.42C977.26 577.2 948 436.34 948 436.34s-43.25 50.24-72.62 130.32C846.4 646 797.84 681.8 865.2 642.42z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M509.47 950.06C665.7 999.9 800 876.84 717.2 835.74 642 798.68 435.3 926.5 509.46 950.06z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M876.85 702.23c3.8-5.36 8.94-22.53 13.48-30.2 27.58-44.52 27.78-80 27.78-80.84 16.66-83.22 15.15-117.2 4.9-180-8.25-50.6-44.32-123.1-75.57-158-32.2-36-9.5-24.25-40.7-50.52-27.33-30.3-53.82-60.3-68.25-72.36C634.22 43.1 636.57 24.58 638.6 21.4l-1.47 1.64C635.87 18.14 635 14 635 14s-57 57-69 152c-7.83 62 15.38 126.68 49 168a381.37 381.37 0 0059 58c25.4 36.48 39.38 81.5 39.38 129.9 0 121.24-98.34 219.53-219.65 219.53a220.45 220.45 0 01-49.13-5.52c-57.24-10.92-90.3-39.8-106.78-59.4-9.45-11.23-13.46-19.42-13.46-19.42 51.28 18.37 108 14.53 142.47-4.52 34.75-19.26 55.77-33.55 72.84-27.92 16.82 5.6 30.2-10.67 18.2-27.54-11.77-16.85-42.4-41-87.88-34.3-34.8 5.07-66.66 29.76-112.24 5.84a96.31 96.31 0 01-8.55-5c-3-1.77 9.77 2.7 6.8.68-8.87-4.32-24.57-13.73-28.64-17.07-.68-.56 6.88 2.16 6.2 1.6-42.62-31.45-37.3-52.7-36-66 1.07-10.66 8.8-24.32 21.86-29.86a152.3 152.3 0 0110.23 5.43l-4.14-7.5c.5-.2 1-.15 1.5-.34a268 268 0 0122.6 11.57c7.83 4.95 10.32 9.36 10.32 9.36s2.06-1 .54-5.33c-.56-1.77-2.93-7.4-10.68-13.07h.48a90.85 90.85 0 0113.13 8.17c2.2-7.12 6.12-14.56 5.25-27.86-.53-9.35-.28-11.78-2.12-15.4-1.65-3.1.92-4.3 3.78-1.1a30 30 0 00-2.44-7.34v-.24c3.57-11.14 75.53-40.12 80.77-43.5a70.31 70.31 0 0021.17-20.63c4-5.72 7-13.73 7.75-25.9.25-5.48-1.44-9.82-20.5-14-11.44-2.5-29.14-4.9-56.43-7.47-19.9-1.76-31.58-14.68-38.2-26.6-1.2-2.57-2.45-4.9-3.68-7.22a53.11 53.11 0 01-2.83-8.36 158.47 158.47 0 0161.28-76.06c1.6-1.3-6.4.33-4.8-1 1.87-1.52 14.06-5.93 16.37-6.92 2.8-1.2-12-6.84-25.16-5.47-13.36 1.35-16.2 2.78-23.32 5.5 3-2.64 12.37-6.1 10.16-6.08-14.4 2-32.3 9.48-47.6 18a9.68 9.68 0 01.92-4.31c-7.13 2.7-24.64 13.67-29.73 23a39.49 39.49 0 00.29-5.35 88.68 88.68 0 00-14.6 13.7l-.27.22c-41.3-14.9-77.68-15.9-108.43-9.2-6.74-6.06-17.57-15.23-32.9-45.4-1-1.82-1.6 3.75-2.4 2-6-13.8-9.55-36.44-9-52 0 0-12.32 5.6-22.5 29.06a152.9 152.9 0 01-4.32 8.87c-.56.68 1.27-7.7 1-7.24-1.77 3-6.36 7.2-8.37 12.62-1.38 4-3.32 6.27-4.56 11.3l-.3.46c-.1-1.48.37-6.08 0-5.14A236.1 236.1 0 0095.34 186c-5.5 18-11.88 42.6-12.9 74.57-.24 2.42 0 5.14-.25 7.32-13 14.83-21.86 27.4-25.2 33.9-16.8 26-35.33 66.44-53.3 130.46a319.14 319.14 0 0128.54-50C17.32 416.25 2.9 469.62 0 551.8a438.52 438.52 0 0113.87-50.24C11.3 556.36 17.68 624.3 52.32 701c20.57 45 67.92 136.6 183.62 208.05 0 0 39.36 29.3 107 51.26l15.23 5.33a93.43 93.43 0 01-4.7-2.05A484.88 484.88 0 00492.27 984c175.18.15 226.85-70.2 226.85-70.2l-.5.38q3.7-3.5 7.14-7.26C698.1 933 635 934.76 611.45 932.87c40.22-11.8 66.7-21.8 118.17-41.52q9-3.36 18.48-7.64l5.8-2.68a349.21 349.21 0 0070.26-44c51.7-41.3 62.95-81.56 68.83-108.1-.82 2.54-3.37 8.47-5.17 12.32-13.3 28.48-42.84 46-74.9 60.95a689 689 0 0042.38-62.44c10.48-10.37 13.7-26.6 21.56-37.53z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M813.92 801c21.08-23.24 40-49.82 54.35-80 36.9-77.58 94-206.58 49-341.3C881.77 273.22 833 215 771.1 158.12 670.56 65.76 642.48 24.52 642.48 0c0 0-116.1 129.4-65.74 264.38s153.46 130 221.68 270.87c80.27 165.74-64.95 346.6-185 397.24 7.35-1.63 267-60.38 280.6-208.88-.35 2.73-6.2 43.8-80.1 77.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M477.6 319.37c.4-8.77-4.16-14.66-76.68-21.46-29.84-2.76-41.26-30.33-44.75-41.94-10.6 27.56-15 56.5-12.64 91.48 1.6 22.92 17 47.52 24.37 62 0 0 1.64-2.13 2.4-2.9 13.86-14.43 71.94-36.42 77.4-39.54 6.02-3.84 28.9-20.56 29.92-47.63z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M158.3 156.47c-1-1.82-1.6 3.75-2.4 2-6-13.8-9.58-36.2-8.72-52 0 0-12.32 5.6-22.5 29.06-1.9 4.2-3.1 6.54-4.32 8.86-.56.68 1.27-7.7 1-7.24-1.77 3-6.36 7.2-8.35 12.38-1.65 4.24-3.35 6.52-4.6 11.77-.4 1.43.4-6.32.05-5.38C84.72 201.68 80.2 271 82.7 268c50.48-53.86 108.3-66.64 108.3-66.64-6.15-4.53-19.53-17.63-32.7-44.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M349.84 720.1c-69.72-29.77-149-71.75-146-167.14C207.92 427.35 321 452.18 321 452.18c-4.27 1-15.68 9.16-19.72 17.82-4.27 10.83-12.07 35.28 11.55 60.9 37.1 40.2-76.2 95.36 98.66 199.57 4.4 2.4-41-1.43-61.64-10.36z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M325.07 657.5c49.44 17.2 107 14.2 141.52-4.86 23.1-12.85 52.7-33.43 70.92-28.35-15.78-6.24-27.73-9.15-42.1-9.86-2.45 0-5.38-.05-8-.32a136.23 136.23 0 00-15.76.86c-8.9.82-18.77 6.43-27.74 5.53-.48 0 8.7-3.77 8-3.6-4.75 1-9.92 1.2-15.37 1.88-3.47.4-6.45.82-9.9 1-103 8.73-190-55.8-190-55.8-7.4 25 33.17 74.3 88.52 93.57z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M813.74 801.65c104.16-102.27 156.86-226.58 134.58-366 0 0 8.9 71.5-24.85 144.63 16.2-71.4 18.1-160.1-25-252C841 205.64 746.45 141.1 710.35 114.2c-54.7-40.8-77.35-82.32-77.78-90.9-16.34 33.48-65.77 148.2-5.3 247 56.64 92.56 145.86 120 208.33 204.95 115.08 156.42-21.85 326.4-21.85 326.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M798.8 535.55C762.4 460.35 717 427.55 674 392c5 7 6.23 9.47 9 14 37.83 40.32 93.6 138.66 53.1 262.1C659.88 900.48 355 791.06 323 760.32c12.93 134.5 238 198.84 384.6 111.63C791 793 858.47 658.8 798.8 535.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.a74be53e187c3a9fbaf7db447ab55314.svg";
export { ForwardRef as ReactComponent };